import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR } from '../data/constants';
export function Hero() {
  return <section className="border-b-4 border-aviation bg-ice" data-id="element-75" data-mp="9lv0spiridvb">
      <div className="h-1.5 bg-navy" aria-hidden="true" data-id="element-76" data-mp="4lqj4w64bd3i" />
      <div className="h-1 bg-gold" aria-hidden="true" data-id="element-77" data-mp="4n9zsnvorq5t" />
      <div className="mx-auto max-w-5xl px-4 pb-5 pt-3 sm:px-6 sm:pb-7 sm:pt-5" data-id="element-78" data-mp="1297esbauxdd0">
        <h1 className="mx-auto max-w-4xl text-center text-[24px] leading-[1.05] text-navy sm:text-5xl" data-id="element-79" data-mp="xae9h65q4snx">
          THE COMPLETE PRIVATE PILOT{' '}
          <span className="text-aviation" data-id="element-80" data-mp="sa9n4zi4x3ps">VISUAL TRAINING &amp; STUDY SYSTEM</span>
        </h1>
        <p className="mx-auto mt-2 max-w-3xl rounded-lg bg-navy px-3 py-1.5 text-center font-display text-sm font-bold uppercase leading-tight text-white sm:text-xl" data-id="element-81" data-mp="nb6lzq59zhn3">
          STOP STRUGGLING TO UNDERSTAND AVIATION THROUGH TEXTBOOKS ALONE.{' '}
          <span className="text-gold" data-id="element-82" data-mp="384s6ut3mwt56">START SEEING HOW FLIGHT REALLY WORKS.</span>
        </p>

        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-graphite sm:text-base" data-id="element-83" data-mp="3j6g1bysfzti2">
          Understand aircraft systems, interpret cockpit instruments, visualize aerodynamics,
          navigate airspace, interpret aviation weather, and explore essential flight
          procedures—
          <strong className="font-semibold text-navy" data-id="element-84" data-mp="3eb8xmqz6aot5">
            all in one complete professional visual learning system.
          </strong>
        </p>

        <MockupImage className="mt-2" priority data-id="element-85" data-mp="359j8jrsrk1yj" />

        <div className="mt-2 flex flex-col items-center" data-id="element-86" data-mp="2qjv9yybyvhei">
          <CTAButton href={OFFER_ANCHOR} data-id="element-87" data-mp="2qlepgmpstof8">🚀 YES! I WANT MY PRIVATE PILOT VISUAL ATLAS NOW</CTAButton>
          <TrustLine items={['🛡️ 7-Day Money-Back Guarantee — Zero Risk']} data-id="element-88" data-mp="2vjga3c2vhvst" />
        </div>
      </div>
    </section>;
}